import { appConfig } from '@utils/config';

export const routes = {
  about: `${appConfig.gameHost}/about`,
  tariffs: `/#subscribe`,
  shop: 'http://shop.chevostik.ru/',
  contacts: `/?feedback=true`
}
